/* eslint-disable @typescript-eslint/no-unused-vars */
import styled, { css } from 'styled-components';
import { CpdsGridItemStyleProps } from '../typings';
import { mapPropsToCss } from '../../utils/mapPropsToCss';

export const CpdsGridItemStylePropsMapper = {
  gridArea: 'grid-area',
  gridColumn: 'grid-column',
  gridRow: 'grid-row',
  rowGap: 'row-gap',
  columnGap: 'column-gap',
  backGroundColor: 'background-color',
  width: 'width',
  maxWidth: 'max-width',
  maxHeight: 'max-height',
  height: 'height',
  padding: 'padding',
  margin: 'margin',
  justifyContent: 'justify-content',
  display: 'display',
  justifySelf: 'justify-self',
  alignSelf: 'align-self',
  placeSelf: 'place-self',
  gridTemplateColumns: 'grid-template-columns',
  flexDirection: 'flex-direction',
  overflow: 'overflow',
  order: 'order',
  alignItems: 'align-items',
  borderRadius: 'border-radius',
  position: 'position',
  top: 'top',
  right: 'right',
  left: 'left',
  bottom: 'bottom',
}

/* Note: By default, this component is rendered as a 'div' element. 
If your use case requires a different HTML element, please update the component accordingly.
Get the the token please use cpds props ex: ${cpds?.button_primary_background_color} */
// const CpdsGridItemStyleTag = styled.div`
//   ${({ theme: { styles : {cpds} } }) => css`
//     /* Start styles for component here */  
//     // Your Styles goes here  
//     /* End styles for component here */

//     /* Styles overrides - Do not Remove This Code Block */
//     /* Data feed styles overrides goes here * /
//     ${(props) => props?.styleOverrides}
//   `}
// `;
// const mapPropsToCss = (props: CpdsGridItemStyleProps) => {
//   return Object.entries(CpdsGridItemStylePropsMapper)
//     .map(([key, cssProp]) => {
//       if (props[key as keyof CpdsGridItemStyleProps]) {
//         return `${cssProp}: ${props[key as keyof CpdsGridItemStyleProps]};`;
//       }
//       return '';
//     })
//     .join(' ');
// };

// const CpdsGridItemStyleTag = styled.div`   
//   ${({ theme, ...props }) => {     
//   const dynamicStyles = props.gridItemStyleProps ? mapPropsToCss(props.gridItemStyleProps) : '';
//   const dynamicStyles = props.gridItemStyleProps ? mapPropsToCss(props.gridItemStyleProps, CpdsGridItemStylePropsMapper, props.gridItemStyleProps.mediaQueries) : '';
//   const { cpds } = theme.styles || {};  
//   return css`
//     ${dynamicStyles}
//     ${props?.styleOverrides || ''} `; }}
//   `;

  const CpdsGridItemStyleTag = styled.div`   
  ${({ theme, ...props }) => {     
  // const dynamicStyles = props.gridStyleProps ? mapPropsToCss(props.gridStyleProps) : '';
  const dynamicStyles = props.gridItemStyleProps ? mapPropsToCss(props.gridItemStyleProps, CpdsGridItemStylePropsMapper, props.gridItemStyleProps.mediaQueries) : '';
  const { cpds } = theme.styles || {};  
  return css` 
    ${dynamicStyles}
    ${props?.styleOverrides || ''} `; }}
  `;

export { CpdsGridItemStyleTag };
